export default class SessionStorageService {
    static keys = {
        // Recent selections in the panel command-search palette (⌘K).
        panelCommandSearchRecent: 'pcsr',
    }

    /**
     * Saves data into session storage
     */
    static set = (name: string, value: string) => {
        return sessionStorage.setItem(name, value);
    };

    /**
     * Extracts the data from session storage
     */
    static get = (name: string | string[]): any | Array<any> => {
        if (typeof name === "string") {
            return sessionStorage[name];
        }
        if (Array.isArray(name)) {
            return name.map(e => sessionStorage[e]);
        }
    };

    /**
     * Returns an array of all the keys in the session storage that are defined in the SessionStorageService.keys object.
     */
    static getAllKeys = () => {
        return Object.values(SessionStorageService.keys);
    }

    /**
     * Removes the key/value pair with the given key from the list associated with the object,
     * if a key/value pair with the given key exists.
     */
    static remove = (name: string) => {
        return sessionStorage.removeItem(name);
    }

    /**
     * Clears every key managed by this service.
     */
    static removeAll = () => {
        for (const key of SessionStorageService.getAllKeys()) {
            SessionStorageService.remove(key);
        }
    }

    /**
     * Returns all the available data from the session storage
     */
    static getAll = () => {
        const keys = SessionStorageService.keys;
        const get = SessionStorageService.get;
        let result: any = {};
        for (let key in keys) {
            result[key] = get(keys[key as keyof typeof keys]);
        }
        return result;
    }
}
